import { render, staticRenderFns } from "./CardRow.vue?vue&type=template&id=4a927bf8&"
import script from "./CardRow.vue?vue&type=script&lang=js&"
export * from "./CardRow.vue?vue&type=script&lang=js&"
import style0 from "./CardRow.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports